import { render, staticRenderFns } from "./OneOnOneView.vue?vue&type=template&id=65f294b2&scoped=true"
import script from "./OneOnOneView.vue?vue&type=script&lang=ts"
export * from "./OneOnOneView.vue?vue&type=script&lang=ts"
import style0 from "./OneOnOneView.vue?vue&type=style&index=0&id=65f294b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f294b2",
  null
  
)

export default component.exports